import { render, staticRenderFns } from "./MobileTabs.vue?vue&type=template&id=2c50cf1f"
import script from "./MobileTabs.vue?vue&type=script&lang=js"
export * from "./MobileTabs.vue?vue&type=script&lang=js"
import style0 from "./MobileTabs.vue?vue&type=style&index=0&id=2c50cf1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports